import { translateGameText } from './gameTextI18n';

export const INGOT_PLATING_META = {
  176: { oreId: 'tas', label: 'Taş Kaplama', color: '#9e9e9e', bonusPercent: 2 },
  177: { oreId: 'bakir', label: 'Bakır Kaplama', color: '#b87333', bonusPercent: 3 },
  178: { oreId: 'demir', label: 'Demir Kaplama', color: '#6b7280', bonusPercent: 4 },
  179: { oreId: 'gumus', label: 'Gümüş Kaplama', color: '#c0c0c0', bonusPercent: 5 },
  180: { oreId: 'altin', label: 'Altın Kaplama', color: '#daa520', bonusPercent: 7 },
  181: { oreId: 'elmas', label: 'Elmas Kaplama', color: '#4fc3f7', bonusPercent: 10 }
};

export const getIngotPlatingMeta = (otherItemId) =>
  INGOT_PLATING_META[Number(otherItemId)] || null;

export const isIngotItemId = (otherItemId) => !!getIngotPlatingMeta(otherItemId);

export const formatPlatingRemaining = (remainingSec) => {
  const sec = Math.max(0, Math.floor(Number(remainingSec) || 0));
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = sec % 60;
  if (h > 0) {
    return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  }
  return `${m}:${String(s).padStart(2, '0')}`;
};

export const getActivePlating = (item) => {
  const plating = item?.plating || item?.baseItem?.plating;
  if (!plating) return null;
  if ((Number(plating.remainingSec) || 0) <= 0) return null;
  if ((Number(plating.bonusPercent) || 0) <= 0) return null;
  const label = translateGameText('platingNames', plating.oreId, plating.label);
  return label === plating.label ? plating : { ...plating, label };
};
